import { render, staticRenderFns } from "./PostGalleryPreview.vue?vue&type=template&id=d0a0bb74"
import script from "./PostGalleryPreview.vue?vue&type=script&lang=ts"
export * from "./PostGalleryPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports